// import { Injectable, signal, computed } from '@angular/core';

// @Injectable({ providedIn: 'root' })
// export class EcommerceService {
// 	readonly _codigo = signal<any | null>(null);
// 	readonly codigo = this._codigo; // signal<string|null>

// 	setCodigo(valor: any | null) {
// 		this._codigo.set(valor);
// 	}
// }

import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface PopupPayload {
	// horaEmbarque?: string;
	// origenFormateado?: string;

	data?: {
		horaEmbarque?: any;
		origenFormateado?: any;
		direccionEmbarque?: any;
		fechaFormateadaIda?: any;
		horaDesembarque?: any;
		destinoFormateado?: any;
		direccionDesembarque?: any;
		fechaFormateadaVuelta?: any;
		escalas?: any;
		localstorage?: any;
	};
	// agrega campos según necesites
}

@Injectable({ providedIn: 'root' })
export class EcommerceService {
	private _openSubject = new BehaviorSubject<number | null>(null);
	readonly open$ = this._openSubject.asObservable();

	open(payload: number) {
		this._openSubject.next(payload);
	}

	close() {
		this._openSubject.next(null);
	}
}
